export default "__VITE_ASSET__BZpr0Jok__"